import { render, staticRenderFns } from "./ver2026.vue?vue&type=template&id=2b23f702&scoped=true"
import script from "./ver2026.vue?vue&type=script&lang=js"
export * from "./ver2026.vue?vue&type=script&lang=js"
import style0 from "./ver2026.vue?vue&type=style&index=0&id=2b23f702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b23f702",
  null
  
)

export default component.exports